<template>
  <div class="payfast-container">
    <v-card class="elevation-3 payfast-card">
      <v-card-title class="header">
        <v-icon left>mdi-credit-card</v-icon>
        Pay via PayFast
      </v-card-title>

      <v-card-text class="pa-6">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_first"
                label="First Name"
                variant="solo"
                rounded
                flat
                hide-details
                prepend-inner-icon="mdi-account"
                :rules="[v => !!v || 'Required']"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="form.name_last"
                label="Last Name"
                variant="solo"
                rounded
                flat
                hide-details
                prepend-inner-icon="mdi-account-outline"
                :rules="[v => !!v || 'Required']"
              />
            </v-col>
          </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.email_address"
              label="Email"
              variant="solo"
              rounded
              flat
              hide-details
              prepend-inner-icon="mdi-email"
              :rules="[
                v => !!v || 'Required',
                v => /.+@.+\..+/.test(v) || 'Invalid email'
              ]"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model.number="form.amount"
              type="number"
              min="5"
              step="0.01"
              label="Amount (ZAR)"
              variant="solo"
              rounded
              flat
              hide-details
              prepend-inner-icon="mdi-currency-zar"
              :rules="[v => !!v || 'Required', v => Number(v) > 0 || 'Must be > 0']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.item_name"
              label="Item Name"
              variant="solo"
              rounded
              flat
              hide-details
              prepend-inner-icon="mdi-tag"
              :rules="[v => !!v || 'Required']"
            />
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="form.item_description"
              label="Item Description (optional)"
              variant="solo"
              rounded
              flat
              hide-details
              prepend-inner-icon="mdi-text"
              rows="3"
              auto-grow
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn :loading="loading" :disabled="!valid || loading" color="#002060" class="pay-btn" rounded large @click="startPayment">
              Pay with PayFast
            </v-btn>
          </v-col>
        </v-row>
        </v-form>

        <div class="note">
          Note: Signatures and secrets are handled server-side for secure payment processing.
        </div>
      </v-card-text>
    </v-card>

    <!-- Hidden dynamic form target -->
    <form ref="payfastForm" :action="processUrl" method="POST" style="display:none">
      <template v-for="(value, key) in postFields" :key="key">
        <input :name="key" :value="value" />
      </template>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Paypast',
  data() {
    return {
      valid: false,
      loading: false,
      // SANDBOX PayFast URL - using sandbox endpoint for testing
      processUrl: 'https://sandbox.payfast.co.za/eng/process',
      functionsBase: process.env.VUE_APP_FUNCTIONS_BASE_URL || 'https://us-central1-dmm-law-user-portal.cloudfunctions.net',
      postFields: {},
      form: {
        name_first: '',
        name_last: '',
        email_address: '',
        amount: null,
        item_name: 'DMM Law Payment',
        item_description: ''
      }
    }
  },
  methods: {
    async startPayment() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      try {
        const origin = window.location.origin;
        const payload = {
          name_first: this.form.name_first,
          name_last: this.form.name_last,
          email_address: this.form.email_address,
          amount: Number(this.form.amount).toFixed(2),
          item_name: this.form.item_name,
          item_description: this.form.item_description || undefined,
          // Using history mode, ensure these are absolute URLs
          return_url: `${origin}/dashboard`,
          cancel_url: `${origin}/dashboard`,
          notify_url: `${this.functionsBase}/payfastItn`
        };

        // Call Cloud Function to build signed fields
        let data;
        try {
          const resp = await fetch(`${this.functionsBase}/createPayfastPayment`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          if (!resp.ok) {
            throw new Error(`HTTP ${resp.status}`);
          }
          data = await resp.json();
          this.processUrl = data.processUrl || this.processUrl;
          this.postFields = data.fields || {};
          // Signature will be included for live merchant
        } catch (networkErr) {
          // Cloud Function unavailable
          console.error('Cloud Function unavailable, cannot proceed with payment.', networkErr);
          alert('Payment service is currently unavailable. Please try again later or contact support.');
          return;
        }

        // Submit hidden form to PayFast
        this.$nextTick(() => {
          this.$refs.payfastForm.submit();
        });
      } catch (e) {
        console.error(e);
        alert('Could not start payment. Please try again.');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.payfast-container {
  max-width: 840px;
  margin: 32px auto;
  padding: 0 16px;
}
.payfast-card {
  border-radius: 16px;
}
.header {
  background-color: #002060;
  color: white;
  border-radius: 16px 16px 0 0;
}
.pay-btn {
  background: #002060 !important;
  color: #fff !important;
  font-weight: 700;
  letter-spacing: 0.4px;
}
.note {
  margin-top: 12px;
  color: #666;
  font-size: 0.9rem;
}
</style>
